import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db } from "firebase/fbConfig.js"

// react component for creating dynamic tables
import ReactTable from "react-table";
import { simpleTableObject } from "components/Table/createReactTableObject.jsx"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Fab from "@material-ui/core/Fab";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import AddIcon from "@material-ui/icons/Add";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/vendorsStyle";
import { Grid } from "@material-ui/core";

// Forms
import AssignActionForm from "components/Forms/AssignActionForm.jsx"
import VendorProfileForm from "components/Forms/vendorProfileForm.jsx"
import AddNewShipperProfileForm from "components/Forms/addNewShipperProfileForm.jsx"


// Firebase Redux Integration
import { startSetPendingActionsList } from 'store/actions/actionsActions'
import { tableToFirestoreObjects, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetUsersList } from "store/actions/adminActions"

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipments: this.props.shipments,
      dataLoaded: false,
      assignActionModal: false,
      volUID: '',
      username: ''
    };
  }

  handleClickOpen = (modal, volUID) => {
    console.log("modal click")
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
      volUID
    });
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  loadData = () => {
    this.setState({
      vendors: simpleTableObject(this.props.vendors),
      dataLoaded: true
    })
  }

  loadVendorsData = (uid, id) => {
    let data = db.collection("TEST-shippers")
    .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            details: doc.id,
            name: docData.name ? docData.name : "N/A",
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        this.setState({
          data: data,
          dataLoaded: true,
          refresh: false
        })
      })
      
    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }


  handleChange = (docID) => {
    console.log(docID)
  }

  render() {
    const { AuthBool, classes } = this.props;

    if (this.state.dataLoaded === false) {
        this.loadVendorsData()
      }
      console.log(this.props.shippers.columns)
      return (
      <div>
        {
          this.state.dataLoaded ? (
            <GridContainer>
              <GridItem xs={12}>
                <Button
                  color="danger"                  
                  onClick={
                    () => this.handleClickOpen("addNewVendorModal",
                      "All"
                    )}
                >ADD NEW SHIPPER</Button>
                
                <div>
                  <ReactTable
                    data={this.state.data}
                    filterable
                    columns={this.props.shippers.columns}
                    defaultPageSize={10}
                    defaultSorted={[
                      {
                        id: "status",
                        desc: false
                      }
                    ]}
                    defaultFiltered={[
                      {
                        id: 'groups',
                        value: 'Logistics Partner'
                      }
                    ]}        
                    //showPaginationTop
                    showPaginationBottom
                    style={{
                      color: "#000"
                    }}
                    className="-striped -highlight"
                  />
                </div>
              </GridItem>
              <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                open={this.state.addNewVendorModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("addNewVendorModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* FORM */}
                    <AddNewShipperProfileForm
                      modalOpen={this.state.addNewVendorModal}
                    />
                 
                  <Button
                    style={{
                      backgroundColor: "black",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("addNewVendorModal")}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>
              <Fab color="primary" aria-label="add" className={classes.fab} onClick={() => this.handleClickOpen("addNewVendorModal")}>
                <AddIcon />
              </Fab>
            </GridContainer>
          ) : (
              <p className={classes.cardSubtitle}>Loading...</p>
            )
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    AuthBool: !!state.auth.user,
    shippers: state.shippers.shipments
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    startSetUsersList: dispatch(startSetUsersList())
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(Users);



// WEBPACK FOOTER //
// ./src/views/Admin/Shippers.jsx